<mat-card class="mat-elevation-z0">
    <mat-card-title class="header">
        <h5 appLocalizationPopupDirective localizationCode="AddNewListOptionValue">
            {{ 'AddNewListOptionValue' | translate: {Default: "Add new list option value"} }}
        </h5>
    </mat-card-title>

    <mat-card-content>
        <app-form-generator
            [formId]="formId"
            [formData]="formData"
            [emitFormDataTrigger]="getFormData"
            (emitFormData)="formDataEmitted($event)"
            (emitFormStatus)="formStatusUpdated($event)"
            (emitFormPristine)="formPristineEmitted($event)"
        ></app-form-generator>

        <button 
            mat-flat-button 
            setColor="primaryColour" 
            color="primary" 
            appPreventDoubleClick 
            (throttledClick)="getFormData = !getFormData" 
            [disabled]="!formValid"
        >{{ 'Save' | translate: {Default: "Save"} }}</button>
    </mat-card-content>
</mat-card>